module.exports = __webpack_public_path__ + "img/海洋环境大数据平台.22a2409b.png";